module.exports = __webpack_public_path__ + "img/tb.6414c354.jpg";